import { CatalogStoreState } from "./types";

// // // //

/**
 * INITIAL_STATE
 * Defines the initial state for the Catalog Redux store
 */
export const INITIAL_STATE: CatalogStoreState = {
    items: [],
    total_asset_count: 0,
    loading: false,
};
